/**
 * DevExtreme (esm/viz/core/themes/fluent.js)
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
var themes = [{
    theme: {
        name: "fluent.blue.light"
    },
    baseThemeName: "material.blue.light"
}, {
    theme: {
        name: "fluent.blue.light.compact"
    },
    baseThemeName: "fluent.blue.light"
}, {
    theme: {
        name: "fluent.blue.dark"
    },
    baseThemeName: "material.blue.dark"
}, {
    theme: {
        name: "fluent.blue.dark.compact"
    },
    baseThemeName: "fluent.blue.dark"
}];
export default themes;
